import { makeStyles } from 'tss-react/mui';

export const useStylesProducView = makeStyles()(theme => {
  return {
    editor: {
      boxShadow: 'initial !important',
      padding: '0 !important',
    },
    container: {
      padding: '0',
      // backgroundColor: '#f2f2f7 !important',
      [theme.breakpoints.up('md')]: {
        // padding: '0 22px',
      },
    },
    backContainer: {
      display: 'flex',
      position: 'relative',
      cursor: 'pointer',
      color: '#006997',
      [theme.breakpoints.down('sm')]: {
        marginLeft: 15,
      },
    },
    backIcon: {
      position: 'absolute',
      left: -20,
      top: 4,
    },
    backTitle: {
      color: '#006997 !important',
      fontSize: 16,
      fontWeight: 'normal',
      fontStyle: 'normal',
      letterSpacing: 'normal',
    },
    card: {
      gap: 24,
      padding: '15px',
      display: 'flex',
      flexDirection: 'column',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      backgroundColor: '#f2f2f7 !important',

      [theme.breakpoints.up('md')]: {
        padding: '25px 0 ',
        // maxWidth: '1280px',
        margin: 'auto',
      },
    },
    leftCol: {
      width: '100%',
      display: 'flex',

      // flexDirection: 'column',
      gap: 20,

      [theme.breakpoints.down(1240)]: {
        flexWrap: 'wrap',
      },
      // [theme.breakpoints.up(1225)]: {
      //   width: '60%',
      // },
      // [theme.breakpoints.up(1450)]: {
      //   width: '50%',
      // },
      // [theme.breakpoints.up(1710)]: {
      //   width: '40%',
      // },
      alignItems: 'center',
    },
    topBlock: {
      width: '100%',
      display: 'flex',
      gap: 20,
      [theme.breakpoints.down(1240)]: {
        flexWrap: 'wrap',
      },
    },
    rightCol: {
      width: '100%',

      // [theme.breakpoints.up(1100)]: {
      //   width: '30%',
      // },
      // [theme.breakpoints.up(1225)]: {
      //   width: '40%',
      // },
      // [theme.breakpoints.up(1450)]: {
      //   width: '50%',
      // },
      // [theme.breakpoints.up(1710)]: {
      //   width: '60%',
      // },
      // [theme.breakpoints.down(1225)]: {
      //   width: '100%',
      // },
    },
    navbar: {
      display: 'flex',
      justifyContent: 'space-between',
      // padding: '0 15px',
      [theme.breakpoints.up('md')]: {
        // padding: '0 50px',
        // maxWidth: '1280px',
        margin: 'auto',
      },
    },
    titleContainer: {
      // display: 'flex',
      // justifyContent: 'space-between',
      // flexWrap: 'wrap-reverse',
      // backgroundColor: 'orange',
    },
    title: {
      fontStyle: 'normal',
      fontWeight: theme.typography.fontWeightBold,
      fontSize: 32,
      color: '#181c32',
      marginBottom: 8,
    },
    pageSubTitle: {
      color: '#181c32',
      fontSize: 20,
      fontWeight: theme.typography.fontWeightMedium,
      padding: 3,
      borderRadius: 4,
    },
    header: {
      display: 'flex',
      flexWrap: 'wrap',
      // justifyContent: 'space-between',
      // flexDirection: 'column',
      // gap: 24,
      // marginLeft: 24,
      alignItems: 'flex-start',
      [theme.breakpoints.down(1455)]: {
        // flexWrap: 'wrap',
      },
      [theme.breakpoints.down(1100)]: {
        //  marginLeft: 0,
      },
    },
    subTitle: {
      fontSize: 22,
      fontWeight: 'bold',
      color: '#000',
      marginBottom: 20,
      fontStyle: 'normal',
    },
    headerLeftParth: {
      width: '100%',
      // [theme.breakpoints.up(1450)]: {
      // },
      padding: 24,
      backgroundColor: '#fff',
      borderRadius: 24,
    },
    headerRightParth: {
      width: '100%',
      // [theme.breakpoints.up(1450)]: {
      //   width: '50%',
      // },
    },
    priceContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: '5px 14px',
      borderRadius: 4,
      '&:nth-child(even)': {
        backgroundColor: '#a3a7b819',
      },
    },
    priceValue: {
      fontSize: '18px !important',
      fontWeight: 'normal !important',
    },
    characteristicsContainer: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      height: '100%',
      // height: 400,
      // minWidth: 450,
      backgroundColor: '#fff',
      borderRadius: 24,
      padding: 24,
    },
    characteristicsContainerFile: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      maxWidth: 352,
      // height: 400,
      height: '100%',
      // minWidth:300,
      backgroundColor: '#fff',
      borderRadius: 24,
      padding: 24,
      [theme.breakpoints.down(1240)]: {
        maxWidth: '100%',
      },
    },
    characteristicsValues: {
      display: 'flex',
      backgroundColor: '#a3a7b819',
      borderLeftRadius: 4,
    },
    characteristicsTest: {
      fontSize: 16,
      fontWeight: 'normal',
    },
    charLeftContainer: {
      borderTopLeftRadius: 4,
      borderBottomLeftRadius: 4,
    },
    charRightContainer: {
      borderTopRightRadius: 4,
      borderBottomRightRadius: 4,
    },
    keysContainer: { width: '100%', borderLeftRadius: 4, padding: 12 },
    valuesContainer: { width: '100%' },
    name: {
      fontSize: 18,
      fontWeight: 600,
      margin: 0,

      [theme.breakpoints.up('md')]: {
        fontSize: 32,
        lineHeight: 1.2,
      },
    },
    price: {
      color: theme.palette.primary.main,
      fontSize: 18,
      fontWeight: 700,

      [theme.breakpoints.up('md')]: {
        fontSize: 32,
        margin: '15px 0',
      },
    },
    whatsAppButton: {
      width: '100%',
      height: 42,
      padding: '12px 20px',
      borderRadius: 4,
      backgroundColor: '#25d366',
      fontSize: 12,
      fontWeight: 'bold',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 'normal',
      letterSpacing: 'normal',
      textAlign: 'center',
      color: '#fff',
      display: 'inline-block',
      marginTop: 20,

      '&:hover': {
        color: '#fff',
      },

      [theme.breakpoints.up('md')]: {
        width: 215,
      },
    },
    companyName: {
      fontSize: 22,
      fontWeight: 'bold',
      color: '#000000',
    },
    companyBrand: {
      fontSize: 18,
      fontWeight: 'normal',
      lineHeight: 'normal',
      color: '#3f6170',
      marginBottom: 16,
      // margin: '16px 0 30px',
    },
    listItem: {
      marginBottom: 15,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '7px 14px',
      borderRadius: 4,
    },
    companyListItem: {
      // marginBottom: 15,
      display: 'flex',
      alignItems: 'center',
      padding: '7px 14px 7px 0',
      borderRadius: 4,
      gap: 10,
      fontSize: 16,
      fontWeight: 'normal',
    },
    caracteristicsListItem: {
      marginBottom: 15,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      // padding: '7px 14px',
      // '&:nth-child(odd)': {
      //   backgroundColor: '#a3a7b819',
      // },
    },
    listValue: {
      fontSize: 16,
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 'normal',
      letterSpacing: 'normal',
      color: '#000000',
      whiteSpace: 'break-spaces',
      margin: 0,
    },
    listValueEnd: {
      fontSize: 16,
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 'normal',
      letterSpacing: 'normal',
      color: '#000000',
      whiteSpace: 'break-spaces',
      margin: 0,
      textAlign: 'end',
    },
    listValueImportant: {
      fontSize: 16,
      fontWeight: 700,
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 'normal',
      letterSpacing: 'normal',
      color: theme.palette.primary.main,
      whiteSpace: 'break-spaces',
      margin: 0,
    },
    listKey: {
      marginBottom: 0,
      fontSize: 15,
      fontWeight: 400,
      color: '#757575',
    },
    companyCard: {
      padding: 24,
      borderRadius: 24,
      backgroundColor: '#a3a7b833',
      // marginTop: 50,
      [theme.breakpoints.down('md')]: {
        // maxWidth:

        marginTop: 0,
      },
    },
    descriptionContainer: {
      borderRadius: 24,
      backgroundColor: '#fff',
      padding: 24,
      width: '100%',
    },
    description: {
      fontSize: 16,
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 'normal',
      letterSpacing: 'normal',
      // color: theme.palette.primary.main,
      // whiteSpace: 'break-spaces',
      margin: 0,
    },
    reviewsContent: {
      display: 'flex',
      flexWrap: 'wrap-reverse',
      marginTop: 15,
      justifyContent: 'space-between',
      [theme.breakpoints.up('md')]: {
        padding: '10px 0',
      },
      width: '100%',
    },
    containerGroups: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
    },
    groupParams: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      width: '100%',
    },
    groupTitle: {
      fontSize: 21,
      fontWeight: 800,
    },
    listItemGroup: {
      marginBottom: 15,
      marginRight: 15,
    },
    containerIcons: {
      display: 'flex',
      flexWrap: 'wrap',
      flexDirection: 'row',
      alignItems: 'center',
    },
    containerIcon: {
      padding: 10,
    },
    containerCharacteristics: {
      overflowY: 'auto',
    },
    tabCommon: {
      fontSize: 16,
      marginBottom: 12,
      fontWeight: 'bold',
      color: '#000',
      fontStyle: 'normal',
    },
    tabAdditional: {
      fontSize: 16,
      marginBottom: 12,
      marginTop: 20,
      fontWeight: 'bold',
      color: '#000',
      fontStyle: 'normal',
    },
    containerAttachments: {
      display: 'flex',
      flexDirection: 'column',
      overflowY: 'auto',
    },
    attachment: {
      display: 'flex',
      flexDirection: 'row',
      padding: 18,
      backgroundColor: '#a3a7b819',
      borderRadius: 4,
      marginBottom: 12,
      gap: 20,
    },
    attachmentTitle: {
      fontSize: 17,
      lineHeight: '17px',
      marginBottom: 6,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      '-webkit-line-clamp': '2',
      '-webkit-box-orient': 'vertical',
      color: '#000',
      fontWeight: theme.typography.fontWeightRegular,
    },
    containerAttachment: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
    },
    size: {
      color: '#6a96c3',
      fontSize: 15,
      fontWeight: theme.typography.fontWeightRegular,
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      padding: 0,
    },
    download: {
      color: '#006997',
      fontSize: 15,
      fontWeight: '400',
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      padding: 0,
    },
    rub: {
      fontSize: '18px !important',
      fontWeight: 'normal !important',
      color: '#7c97c0',
    },
    containerCount: {
      display: 'flex',
      width: '100%',
      justifyContent: 'end',
      marginTop: 16,
      paddingRight: 4,
    },
    count: {
      maxWidth: 200,
    },
    countContainer: {
      justifyContent: 'start',
    },
    save: {
      textTransform: 'inherit',
      height: 48,
      fontSize: 17,
      fontWeight: theme.typography.fontWeightRegular,
      color: '#fff',
      width: 180,
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        fontSize: 16,
        height: 44,
      },
    },
    actions: {
      display: 'flex',
      gap: 20,
      flexDirection: 'row',
      marginTop: 16,
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        gap: 12,
        width: '100%',
      },
    },
  };
});
